(() => {
  'use strict';

  // Das Skript haengt in der Section main-product; der Theme-Editor fuehrt
  // Section-Skripte bei shopify:section:load erneut aus. Ohne diese Sperre
  // haetten wir danach doppelte Listener und einen zweiten Beobachter.
  if (window.dreissigackerPdpGrowth) return;
  if (!document.body?.classList.contains('template-product')) return;
  window.dreissigackerPdpGrowth = true;

  /* Kein MutationObserver auf dem Produktbereich: jede Funktion hier aendert
     selbst das DOM, ein Beobachter darauf wuerde sich selbst ausloesen und in
     jedem Frame erneut laufen (Browser haengt, sobald das Mengenfeld aufgeht).
     enhance() laeuft deshalb nur beim Laden und nach den Theme-Ereignissen,
     die den Produktbereich neu aufbauen (variant:change, shopify:section:load,
     pageshow). */

  /* Wishlist Hero liefert seinen Knopf nur auf Englisch; die Beschriftung
     kommt aus der Sprachdatei (product.general.open_wishlist, ausgegeben in
     sections/main-product.liquid). */
  const wishlistLabel = document.querySelector('.shopify-section--main-product [data-wishlist-label]')?.dataset.wishlistLabel;
  const translateWishlist = Boolean(wishlistLabel) && wishlistLabel !== 'Open Wishlist';

  function localizeWishlist() {
    if (!translateWishlist) return false;

    let changed = false;
    document.querySelectorAll('[aria-label="Open Wishlist"]').forEach((element) => {
      element.setAttribute('aria-label', wishlistLabel);
      changed = true;
    });
    document.querySelectorAll('[title="Open Wishlist"]').forEach((element) => {
      element.setAttribute('title', wishlistLabel);
      changed = true;
    });
    return changed;
  }

  function enhanceGalleryCounter(main) {
    const gallery = main.querySelector('product-gallery');
    if (!gallery || gallery.querySelector('.pdp-gallery-counter')) return;
    if (gallery.querySelector('.scroll-marker-group--counter')) return;

    const controls = Array.from(gallery.querySelectorAll('carousel-navigation .scroll-marker'))
      .filter((button) => !button.hidden);
    if (controls.length <= 1) return;

    const host = gallery.querySelector('.product-gallery__image-list > .relative');
    if (!host) return;

    const counter = document.createElement('span');
    counter.className = 'pdp-gallery-counter';
    counter.setAttribute('aria-hidden', 'true');
    host.append(counter);

    const update = () => {
      const visibleControls = controls.filter((button) => !button.hidden);
      const current = visibleControls.findIndex((button) => button.getAttribute('aria-current') === 'true');
      const index = current >= 0 ? current + 1 : 1;
      const text = `${index} / ${visibleControls.length}`;
      if (counter.textContent !== text) counter.textContent = text;
    };

    /* Beobachtet nur Attribute der Galerie-Punkte, schreibt nur in den eigenen
       Zaehler: kann keine Schleife bilden. */
    const observer = new MutationObserver(update);
    controls.forEach((button) => observer.observe(button, { attributes: true, attributeFilter: ['aria-current', 'hidden'] }));
    update();
  }

  function enhance() {
    // Bei jedem Lauf neu aufloesen: der Theme-Editor ersetzt den
    // Section-Container, eine gemerkte Referenz zeigte dann ins Leere.
    const main = document.querySelector('.shopify-section--main-product');
    if (!main) return;
    localizeWishlist();
    enhanceGalleryCounter(main);
  }

  let scheduled = false;
  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  /* Wishlist Hero wird von der App nachtraeglich eingefuegt. Kurz beobachten,
     nach dem ersten Treffer oder spaetestens nach 10 Sekunden aufhoeren. */
  if (translateWishlist && !localizeWishlist()) {
    const wishlistObserver = new MutationObserver(() => {
      if (localizeWishlist()) wishlistObserver.disconnect();
    });
    wishlistObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => wishlistObserver.disconnect(), 10000);
  }

  window.addEventListener('pageshow', scheduleEnhance);
  document.addEventListener('variant:change', scheduleEnhance);
  document.addEventListener('shopify:section:load', scheduleEnhance);

  enhance();
})();
